"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports.CheckType=void 0;var c;(function(e){e.Map="map",e.Search="search"})(c||(exports.CheckType=c={}));
//# sourceMappingURL=CheckType.js.map
